import * as React from 'react';

import { GaPageLabel } from '../../services/AnalyticsService';

import ClosableModal from './ClosableModal';

interface IClosableMobileFullScreenModalProps {
  children?: React.ReactNode;
  gaPage: GaPageLabel;
  gaGroup: string;
  className?: string;
}

export default class MobileFullScreenClosableModal extends React.Component<IClosableMobileFullScreenModalProps> {
  public render(): JSX.Element {
    return (
      <ClosableModal
        gaPage={this.props.gaPage}
        gaGroup={this.props.gaGroup}
        className={this.props.className}
        modalProps={{
          responsive: [
            { breakPoint: 'xs', props: { isFullScreen: true } },
            { breakPoint: 'md', props: { isFullScreen: false } }
          ]
        }}
      >
        {this.props.children}
      </ClosableModal>
    );
  }
}
